// removed by extract-text-webpack-plugin
module.exports = {"field":"field__field","field-pill":"field__field-pill","wildcard-field-pill":"field__wildcard-field-pill","func":"field__func","caret-type":"field__caret-type","type":"field__type","text":"field__text","fn-text":"field__fn-text","filter-button-unadded":"field__filter-button-unadded"};


//////////////////
// WEBPACK FOOTER
// ./src/components/field/field.scss
// module id = 1221
// module chunks = 0